import { useGetRegionPageAvailableFavoriteProducts } from 'api/regions/hooks';
import { useFetchLocationAvailableModulesContent } from 'api/locations/hooks';
import { useFetchFavoriteProducts } from 'api/products/hooks';
import { useParams } from 'react-router-dom';
import { useSelectedProfileStore } from 'stores/selectedProfileStore';

export const useLocationProductAvailableItems = () => {
  const { locationUid } = useParams();
  const { data, isLoading } = useFetchLocationAvailableModulesContent(locationUid);

  return { items: data?.favorite_products || [], isLoading };
};

export const useStoreProductAvailableItems = () => {
  const { data, isLoading } = useFetchFavoriteProducts();

  return { items: data || [], isLoading };
};

export const useRegionProductAvailableItems = () => {
  const selectedRegion = useSelectedProfileStore((state) => state.selectedRegionUid);
  const { data, isLoading } = useGetRegionPageAvailableFavoriteProducts(selectedRegion);

  return { items: data || [], isLoading };
};
